module.exports = __webpack_public_path__ + "static/bathroom-f36d77eb3dd6a088e35364e9c891be07.jpg";